export const API_PATH_apiUserMngmtUserPut = '/services/users-management/user';
